// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__3p_sT","page":"app_page__e0POX","activePage":"app_activePage__1RNET"};